export const environment = {
  production: true,
  API_DOMAINS: {
    LOGIN: 'https://serhafen.andinolabs.tech/auth',
    USERS: 'https://serhafen.andinolabs.tech/users',
    MAWB: 'https://serhafen.andinolabs.tech/awb',
    AWB_HEADER: 'https://serhafen.andinolabs.tech/awb/header',
    MASTER_FLIGHTS: 'https://serhafen.andinolabs.tech/flights',
    TRUCK_TRAVEL: 'https://serhafen.andinolabs.tech/truck/travel',
    TRUCKS: 'https://serhafen.andinolabs.tech/truck/travel/trucks',
    COMPANY: 'https://serhafen.andinolabs.tech/truck/travel/companies',
    TYPE_TRAVEL: 'https://serhafen.andinolabs.tech/truck/travel/type',
    FLIGHTS: 'https://serhafen.andinolabs.tech/flights',
    MAWB_DETAIL: 'https://serhafen.andinolabs.tech/mawb',
    AWB_ROUTE: 'https://serhafen.andinolabs.tech/awb/detail/route',
    FLOW: 'https://serhafen.andinolabs.tech/flow',
    STATUS_CODES: 'https://serhafen.andinolabs.tech/status-code',
    KEY_WORDS: 'https://serhafen.andinolabs.tech/key-word',
    EXTERNAL: 'https://serhafen.andinolabs.tech/external',
    RECEIVED_MESSAGES: 'https://serhafen.andinolabs.tech/received-messages',
    COUNTRY: 'https://serhafen.andinolabs.tech/country',
    NEWS: 'https://serhafen.andinolabs.tech/news',
    ITINERARY: 'https://serhafen.andinolabs.tech/itinerary',
    PRE_ALERT: 'https://serhafen.andinolabs.tech/pre/alert',
    GOVERNMENT_ADDRESS: 'https://serhafen.andinolabs.tech/government-address',
    STATUS_CODE_COMPANY: 'https://serhafen.andinolabs.tech/status-code-company',
    PRE_ALERT_EXCEL_UPLOAD: 'https://serhafen.andinolabs.tech/pre-alert',
    SUNAT: 'https://serhafen.andinolabs.tech/sunat',
    ENV: 'PROD',
  },
  GLOBAL_SETTINGS: {
    MESSAGE_LOADING_INFORMATION: 'Cargando información, por favor espere un momento ...',
    MESSAGE_PROCESSING_INFORMATION: 'Procesando información, por favor espere un momento ...',
    GENERATING_DOCUMENT: 'Generando documento, por favor espere un momento ...',
  },
  TYPE: 'pc',
  CONSTANTS: {
    QUERY_HAWBS_BY_TRACKING_ID: true,
    AUTO_REFRESH_DATA_GRID_TOGGLE: true,
    AUTO_REFRESH_SUMMARY_PANNEL_TOGGLE: true,
    INVOICE_WORD_TOGGLE: true,
    IS_BATCH_FILE_TAB_DISABLE: true,
  },
};
